var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhite2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 116",
    width: 384,
    height: 116,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo_white-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffffff } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m335.1 74.4v-23.2q-0.1-3.7-2.4-5.9-2.4-2.1-5.7-2.1-2.2 0-4.1 0.9-2 1-3 2.9-1.1 1.8-1.1 4.2v23.2h-10.6v-23.2q0-3.7-2.4-5.9-2.3-2.1-5.7-2.1-2.4 0-4.2 0.9-1.9 1-3 2.8-1.1 1.8-1.1 4.3v23.2h-10.6v-39.3h10.6v4.8l2.3-2q1.2-1.1 2.7-1.9c2.2-1.2 4.8-1.8 7.8-1.8 2.6 0 5 0.6 7.1 1.8 1.6 0.9 2.9 2 4 3.4l1 1.3 1.1-1.3q1.8-2 4.2-3.3c2.5-1.2 5.3-1.9 8.3-1.9 2.9 0 5.6 0.6 7.9 1.9 2.3 1.2 4.2 3 5.5 5.2 1.3 2.3 2 5.1 2 8.3v24.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m263.4 75.9v-1.9h-13.5c-10.3 0-15.7-9.9-15.7-19.6 0-11.5 6.2-19.3 15.7-19.7h21.3v41.2zm-12.1-32.7c-5.5 0.2-9.3 4.7-9.3 11.1q0 0.1 0 0.1c0 5.6 3.2 11.3 9.4 11.3h12v-22.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m207.8 105.1c-11.6 0-19.4-6.1-19.9-15.6v-10.6h8.7v9.2c-0.1 2.2 0.7 4.3 2.3 5.9 2.1 2.1 5.5 3.4 9.1 3.4 5.3 0 11.1-2.9 11.2-9.3v-14h-14.5c-11.7-0.2-16.9-10-16.9-19.6 0.1-9.8 5.8-19.7 16.6-19.7q0.1 0 0.3 0h23.1v54.8c0 10.2-10 15.5-20 15.5zm2.2-61.9c-6.3 0-13.1 0.8-13.6 11.1v0.1 0.1c0.5 10.4 7.1 11.3 13.1 11.3 1.1 0 2.1 0 3.2 0q1.7-0.1 3.4-0.1 0.8 0 1.7 0l1.4 0.1v-22.6l-1.4 0.1q-0.7 0-1.4 0-1.7 0-3.3-0.1-1.6 0-3.1 0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m172.3 75.9v-1.8h-13.5c-10.3 0-15.7-9.9-15.7-19.7 0-11.5 6.2-19.2 15.7-19.6h21.3v41.1zm-12.1-32.6c-5.5 0.2-9.3 4.7-9.3 11.1q0 0 0 0.1c0 5.6 3.2 11.2 9.4 11.2h12v-22.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m98.6 34.5h11.4l9.9 28.8 10-28.8h11.1l-16.8 39.5-8.9 0.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m67.5 75.9v-1.8h-13.5c-10.3 0-15.7-9.9-15.7-19.7 0-11.5 6.2-19.2 15.8-19.6h21.2v30.9h8.1l0.1-1.3v-29.6h7.8v39.3h-16v1.8zm-12.1-32.6c-5.5 0.2-9.2 4.7-9.3 11.1q0 0 0 0.1c0 5.6 3.3 11.2 9.4 11.2h12v-22.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m99.5 15.9c0-1.7-1.3-3-3-3-1.2 0-2.3 0.8-2.7 1.9-0.3 0.4-2.2 4.1-6.3 4.5-2.5 0.3-4.5 2.4-4.5 4.9 0 2.7 2.2 4.9 4.9 4.9 2.5 0 4.5-1.8 4.9-4.1 1.1-4.8 4.7-6.3 4.7-6.3 1.2-0.4 2-1.5 2-2.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite2);
export default __webpack_public_path__ + "static/media/logo_white2.51b2c285217fe20105ca3cc44d9406b3.svg";
export { ForwardRef as ReactComponent };